import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Grid,
  Box,
  CardMedia,
  TextField,
  Button,
  MenuItem,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import default_theme from "assets/themes/themes";
import { blueTextFieldStyles } from "assets/themes/textFieldStyles";
import styles from "../../../pages/main/WorkspacesPage/WorkspacesPage.module.css";

const WorkspacesPageDialog = ({
  open,
  onClose,
  onSave,
  form,
  setForm,
  frameworks,
  editingProjectId,
  fileInputRef,
  onImageChange,
}) => {
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle
        variant="h5"
        className={styles.dialogTitle}
      >
        {editingProjectId ? "Edit project" : "Create a new project"}
      </DialogTitle>

      <DialogContent dividers>
        <Typography variant="body1"
          sx={{ color: "#7898A4", mb: 4 }}
        >
          Add a name, image and short description. You will be able to
          configure more details later.
        </Typography>

        <Grid container spacing={3} className={styles.formGrid}>
          {/* IMAGE */}
          <Grid item xs={12} md={4}>
            <Box className={styles.imageUploadContainer}>
              {form.imagePreview ? (
                <CardMedia
                  component="img"
                  image={form.imagePreview}
                  alt={form.name || "Project image"}
                  className={styles.imagePreview}
                />
              ) : (
                <Box
                  className={styles.imagePlaceholder}
                  onClick={() => fileInputRef.current?.click()}
                  sx={{ cursor: "pointer" }}
                >
                  <Typography
                    variant="body2"
                    className={styles.imagePlaceholderText}
                  >
                    Click to upload image
                  </Typography>
                </Box>
              )}

              <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                onChange={onImageChange}
              />
            </Box>
          </Grid>

          {/* FORM */}
          <Grid item xs={12} md={8}>
            <Box className={styles.formFields}>
              <TextField
                label="Project name"
                name="name"
                value={form.name}
                onChange={handleInputChange}
                fullWidth
                size="small"
                sx={(theme) => blueTextFieldStyles(theme)}
              />

              <TextField
                label="Short description"
                name="description"
                value={form.description}
                onChange={handleInputChange}
                fullWidth
                multiline
                minRows={3}
                sx={(theme) => blueTextFieldStyles(theme)}
              />

              <TextField
                select
                label="Framework"
                name="frameworkId"
                value={form.frameworkId}
                onChange={handleInputChange}
                fullWidth
                size="small"
                sx={(theme) => blueTextFieldStyles(theme)}
              >
                {frameworks?.map((framework) => (
                  <MenuItem key={framework.id} value={framework.id}>
                    {framework.name}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button
          onClick={onClose}
          variant="contained"
          startIcon={<CloseIcon />}
          className={styles.cancelButton}
        >
          Cancel
        </Button>

        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={onSave}
          className={styles.saveButton}
        >
          {editingProjectId ? "Save changes" : "Create project"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WorkspacesPageDialog;